<template>
  <div class="news wd-1200">
    <div>
      <moduleTitle :large="true" :moduleFlag="moduleFlag" />
      
      <div class="news-list" v-for="(item, index) in moduleInfo" :key="index">
        <div class="news-list-item">
          <img @click="handleCheckNews(item.url)" :src="item.image" />
          <div class="news-list-info">
            <p @click="handleCheckNews(item.url)">{{ item.title }}</p>
            <p>{{ item.time }}</p>
            <p>{{ item.summary }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dataMixins from '@/mixins/pc/data';
import moduleTitle from '@/components/pc/module-title';

export default {
  components: { moduleTitle },
  mixins: [dataMixins],
  data() {
    return {
      moduleInfo: this.getModuleData(),
    };
  },
  methods: {
    handleCheckNews(url) {
      window.location.href = url;
    },
  },
  created() {
    console.log('this.moduleInfo', this.moduleInfo);
  },
};
</script>

<style scoped lang="scss">
.news {
  padding-bottom: 70px;

  .news-list {
    width: 1186px;
    margin: 0 8px 0;

    .news-list-item {
      width: 100%;
      height: 162px;
      box-sizing: border-box;
      overflow: hidden;
      margin-bottom: 30px;
      box-shadow: 0 0 24px 0 rgba(39, 73, 255, 0.1);

      img {
        display: inline-block;
        width: 288px;
        height: 100%;
        margin-right: 20px;
        float: left;
        cursor: pointer;
      }

      .news-list-info {
        width: 878px;
        color: #a6a6a6;
        float: left;

        p {
          margin: 0;
        }

        p:nth-of-type(1) {
          cursor: pointer;
          font-size: 16px;
          line-height: 20px;
          color: #333;
          padding: 20px 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &:hover {
            color: var(--themeColor);
          }
        }

        p:nth-of-type(2) {
          font-size: 14px;
          line-height: 16px;
          padding-bottom: 24px;
        }

        p:nth-of-type(3) {
          font-size: 14px;
          line-height: 24px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
